module.exports = __webpack_public_path__ + "img/free2read-success.2a44e30d.png";